import React, { useEffect } from 'react'
import Abouttwoimg01 from '../../../assets/images/personal.png';
import Abouttwoimg02 from '../../../assets/images/Team.png';
import Abouttwoimg03 from '../../../assets/images/Team-icon.svg';
import Abouttwoimg04 from '../../../assets/images/accounting.svg';
import Abouttwoimg05 from '../../../assets/images/contract.svg';

const Abouttwo = () => {
    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll(
                '.about-two-image'
            );

            elements.forEach((el) => {
                const elementTop = el.getBoundingClientRect().top;
                const elementBottom = el.getBoundingClientRect().bottom;
                const viewportTop = 0;
                const viewportBottom = window.innerHeight;

                if (elementBottom > viewportTop && elementTop < viewportBottom) {
                    el.classList.add('active');
                }
            });
        };


        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (
        <div className="about-two">
            <div className="container">
                <div className="row gutter-y-60">
                    <div className="col-lg-6 col-md-12 about-two-left">
                        <div className="about-two-image">
                            <img
                                src={Abouttwoimg01}
                                alt="about-image"
                            />
                            <div className="image-shape">
                                <span />
                                <span />
                            </div>
                        </div>
                        {/* <div className="about-two-cta-box">
                            <div className="client-list">
                                <img src={Abouttwoimg02} alt="team" />
                            </div>
                            <div className="about-two-info-right">
                                <h5>Our Expert Team</h5>
                                <p className="mb-0">
                                    A global customer refers to an individual or business entity that
                                    operates.
                                </p>
                            </div>
                            <div className="about-two-cta-box-icon">
                                <img width={50} src={Abouttwoimg03} alt="icon" />
                            </div>
                        </div> */}
                    </div>
                    <div className="col-lg-6 col-md-12 about-two-right">
                        <div className="heading-box">
                            {/* <span className="heading-subtitle wow fadeInUp animated animated">
                                🤝 ABOUT US
                            </span> */}
                            <h2 className="heading-title wow fadeInUp animated animated pt-2 pb-0 mb-2">
                                Global Expertise. Personal Touch.
                            </h2>
                            <p className="heading-details mt-0 pt-0 ">
                                At NRI Advisors, we are here to make things easier for you, no matter where in the world you are. We handle everything from property matters and legal paperwork to finances, travel plans, and even those little details that make a big difference.
                            </p>
                            <p>Behind every service we offer is a team of real people who genuinely care about getting things right for you. We listen, we understand, and we tailor our services to fit your unique needs. Whether it’s sorting out taxes, planning a family event back home, or just making sure your documents are in order, we’ve got your back. And because trust matters, we promise transparency, honesty, and a personal touch in everything we do.</p>
                            <p>So go ahead, focus on your life abroad. Let us take care of the rest, as your extended team – always ready, always reliable. </p>
                        </div>
                        {/* <h4>One team. One point of contact. Total peace of mind.</h4> */}
                        {/* <ul className="about-two-list">
                            <li>
                                <i className="flaticon-checked" /> One-Stop, All-in-One Advisory
                            </li>
                            <li>
                                <i className="flaticon-checked" /> NRI-Focused Legal & Compliance Expertise
                            </li>
                            <li>
                                <i className="flaticon-checked" />Trusted On-Ground Representation
                            </li>
                            <li>
                                <i className="flaticon-checked" /> Regular Visual Proof & Updates
                            </li>
                            <li>
                                <i className="flaticon-checked" /> Fraud Protection & Risk Shielding
                            </li>
                            <li>
                                <i className="flaticon-checked" /> Dedicated Relationship Manager
                            </li>
                            <li>
                                <i className="flaticon-checked" /> Transparent, Step-by-Step Legal Processes
                            </li>
                            <li>
                                <i className="flaticon-checked" />Language & Cultural Sensitivity
                            </li>
                            <li>
                                <i className="flaticon-checked" />Quick replies via Zoom, WhatsApp, Email
                            </li>
                            <li>
                                <i className="flaticon-checked" />Long term Post-service engagementTrusted On-Ground 
                            </li>
                            <li>
                                <i className="flaticon-checked" /> RepresentationTrusted On-Ground Representation
                            </li>
                        </ul> */}
                        {/* <div className="row gutter-y-30">
                            <div className="col-xl-6 col-lg-12">
                                <div className="about-two-box">
                                    <div className="about-two-box-icon">
                                        <img src={Abouttwoimg04} alt="icon" />
                                    </div>
                                    <div className="about-two-box-title">
                                        <h4>Competitive Interest Rates</h4>
                                    </div>
                                    <div className="about-two-box-info">
                                        <p>
                                            we offer some of the most competitive interest rates in the
                                            industry, ensuring you get the best value for your loan.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-12">
                                <div className="about-two-box">
                                    <div className="about-two-box-icon">
                                        <img src={Abouttwoimg05} alt="icon" />
                                    </div>
                                    <div className="about-two-box-title">
                                        <h4>Expert Guidance Every Step</h4>
                                    </div>
                                    <div className="about-two-box-info">
                                        <p>
                                            we offer expert guidance at every step of your loan journey.
                                            Our experienced team.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>

    )
}
export default Abouttwo;